
export const STATUS = {
    SUFICIENTE : 'suficiente',
    COMPLETO: 'completo',
    REVISAR_DIRECCION: 'revisar_direccion',
    OK_CONJUNTO: 'ok_conjunto'
}